/* Accordéons (footer mobile) */
$('.accordion-sitemap').click(function() {
    var $this = $(this);
    var $content = $this.next('.accordion-sitemap__content');

    $content.toggleClass('opened');
});

$('.list-supports__category').click(function() {
    var $this = $(this);
    //var $content = $this.next('.list-supports__items');

    $this.toggleClass('opened');
});

$('.thematic-search__title.thematic-search__select').click(function() {
    var $this = $(this);
    var $list = $this.next('.thematic-search__tags-list');

    $list.toggleClass('opened');
});
